import React from "react";


// const Environment = "PRODUCTION";
 const Environment = "TESTING";
// const Environment = "DEVELOPMENT";
// const Environment = "LOCAL";

const URL =
  Environment === "PRODUCTION"
    ? "https://pharmasolo.com"
    : Environment === "TESTING"
    ? "https://testing.pharmasolo.com"
    : Environment === "DEVELOPMENT"
    ? "https://development.pharmasolo.com"
    : Environment === "LOCAL"
    ? "http://localhost:5002"
    : "";

// const URL =
//   Environment === "PRODUCTION"
//     ? "https://managepharmacys.com"
//     : Environment === "TESTING"
//     ? "https://testing.managepharmacys.com"
//     : Environment === "DEVELOPMENT"
//     ? "https://development.managepharmacys.com"
//     : Environment === "LOCAL"
//     ? "http://localhost:5002"
//     : "";

export default URL;

/** 25/12/2025
 * sales edit uptated, recv sale price transfer rcv updated, bill serach reset updated  
 */

/**
 *  26/12/2025
 *  bug fix for in dashboard sales & other - deploy 26/12/2025
 */
/**
 * 28/12/2025
 * bug fix in Ui cash closing report for formate date
 */